<template>
  <h1 class="page-title tc"><span>☆</span> {{ title }} <span>☆</span></h1>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: { type: String, default: 'Do you sound like Biden or Trump?' }
  }
}
</script>

<style scoped>
  .page-title {
    position: relative;
    font-size: 46px;
    color: #fff;
    background: rgba(10, 12, 52, 0.8);
    font-weight: bold;
    padding: 28px 90px;
  }
 .page-title span {
    position: absolute;
    top: 50%;
    left: 30px;
    transform: translateY(-50%);
    font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
  }

  .page-title span:last-child {
    left: auto;
    right: 30px;
  }
  @media (max-width: 768px) {
    .page-title {
      font-size: 26px;
      padding-left: 65px;
      padding-right: 65px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Title.vue